import playerData from "../static/player_json/player_data.json";
import userData from "../static/player_json/user_data.json";
import adpData from "../static/player_json/ffid.json";
import rawData from "../static/player_json/rawData.json";

const PlayerData = {
  getPlayerData(): any {
    return playerData;
  },

  getUserData(): any {
    return userData;
  },

  getADPData(): any {
    return adpData;
  },

  getRawData(): any {
    return rawData;
  }
};

export default PlayerData;
